import InfoPage from '@/components/InfoPage';

const TermosUso = () => {
  return (
    <InfoPage title="Termos de Uso">
      <div className="space-y-6 text-gray-700">
        <p><strong>Última atualização:</strong> Janeiro de 2025</p>
        
        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e usar o ParkingSpot, você concorda com estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não use nosso serviço.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>2. Descrição do Serviço</h2>
          <p>
            O ParkingSpot é uma plataforma gratuita que conecta motoristas a estacionamentos disponíveis. Fornecemos informações em tempo real sobre vagas, preços e localização.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>3. Cadastro de Usuário</h2>
          <p>Para usar certas funcionalidades, você deve criar uma conta. Você concorda em:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Fornecer informações precisas e atualizadas</li>
            <li>Manter a segurança de sua conta</li>
            <li>Notificar-nos imediatamente sobre qualquer uso não autorizado</li>
            <li>Ser responsável por todas as atividades em sua conta</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>4. Responsabilidades do Proprietário</h2>
          <p>Se você cadastra um estacionamento, você concorda em:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Fornecer informações precisas sobre seu estacionamento</li>
            <li>Manter as informações de vagas atualizadas</li>
            <li>Definir preços justos e transparentes</li>
            <li>Cumprir todas as leis e regulamentações aplicáveis</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>5. Limitação de Responsabilidade</h2>
          <p>
            O ParkingSpot atua apenas como plataforma de informações. Não somos responsáveis por:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Disponibilidade real de vagas</li>
            <li>Preços praticados pelos estacionamentos</li>
            <li>Qualidade ou segurança dos estacionamentos</li>
            <li>Transações entre motoristas e proprietários</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>6. Modificações</h2>
          <p>
            Reservamo-nos o direito de modificar estes termos a qualquer momento. Notificaremos sobre mudanças significativas através do email cadastrado.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3" style={{ color: '#302681' }}>7. Contato</h2>
          <p>Para questões sobre estes termos:</p>
          <p className="mt-2">Email: legal@parkingspot.com.br</p>
        </section>
      </div>
    </InfoPage>
  );
};

export default TermosUso;
